// Data for the New 7 Wonders presentation.
// IMAGES: Local files. Place these JPG files inside the `images/` folder
// next to index.html. They are loaded with relative paths so the
// presentation works completely OFFLINE (no internet required).
//
// Required image filenames (case-sensitive):
//   Greatwall.jpg, Petra.jpg, Christ.jpg, Colosseum.jpg,
//   MachuPicchu.jpg, TajMahal.jpg, Chichen.jpg

const img = (filename) => `${process.env.PUBLIC_URL || ""}/images/${filename}`;

export const wonders = [
  {
    id: "great-wall",
    name: "Great Wall of China",
    country: "China",
    flag: "🇨🇳",
    continent: "Asia",
    builtBy: "Many Chinese Emperors",
    age: "Over 2,000 years old",
    image: img("Greatwall.jpg"),
    summary:
      "A super long wall built to protect China from invaders long ago - one of the most famous places in the world.",
    funFact: "It stretches more than 21,000 kilometers - longer than any other wall ever built!",
    vocabulary: { word: "Fortress", meaning: "A strong building made to defend against attacks." },
    didYouKnow: "Some parts of the wall are more than 2,000 years old.",
    emoji: "🐉",
    accent: "#FFB703",
  },
  {
    id: "petra",
    name: "Petra",
    country: "Jordan",
    flag: "🇯🇴",
    continent: "Asia",
    builtBy: "The Nabataeans",
    age: "Over 2,000 years old",
    image: img("Petra.jpg"),
    summary:
      "An ancient city carved into pink and red rocks where desert traders once stopped to rest.",
    funFact: "Petra is called the 'Rose City' because of its beautiful pink stone.",
    vocabulary: { word: "Ancient", meaning: "Belonging to a time that was a very, very long ago." },
    didYouKnow: "Many of Petra's buildings were carved directly into mountains.",
    emoji: "🌹",
    accent: "#FB5607",
  },
  {
    id: "christ-redeemer",
    name: "Christ the Redeemer",
    country: "Brazil",
    flag: "🇧🇷",
    continent: "South America",
    builtBy: "Heitor da Silva Costa (designer)",
    age: "Built in 1931",
    image: img("Christ.jpg"),
    summary:
      "A giant statue of Jesus standing high above Rio de Janeiro that welcomes visitors from all over the world.",
    funFact: "The statue is about 30 meters tall - as tall as a 10-story building!",
    vocabulary: { word: "Statue", meaning: "A carved or sculpted figure of a person or animal." },
    didYouKnow: "Lightning strikes the statue many times every year.",
    emoji: "✝️",
    accent: "#06B6D4",
  },
  {
    id: "machu-picchu",
    name: "Machu Picchu",
    country: "Peru",
    flag: "🇵🇪",
    continent: "South America",
    builtBy: "The Inca Civilization",
    age: "About 600 years old",
    image: img("MachuPicchu.jpg"),
    summary:
      "An ancient Inca city high up in the Andes Mountains that was hidden for many years before being rediscovered.",
    funFact: "It sits nearly 2,500 meters above sea level - way up in the clouds!",
    vocabulary: { word: "Mountain", meaning: "A very tall, rocky area of land that rises high above the ground." },
    didYouKnow: "Many people call Machu Picchu the 'Lost City of the Incas'.",
    emoji: "🏔️",
    accent: "#10B981",
  },
  {
    id: "chichen-itza",
    name: "Chichen Itza",
    country: "Mexico",
    flag: "🇲🇽",
    continent: "North America",
    builtBy: "The Maya Civilization",
    age: "Over 1,000 years old",
    image: img("Chichen.jpg"),
    summary:
      "An important Mayan city famous for its huge pyramid called El Castillo, the Castle of the Sun.",
    funFact: "The pyramid has exactly 365 steps - one for every day of the year!",
    vocabulary: { word: "Pyramid", meaning: "A building with four triangle-shaped sides that meet at the top." },
    didYouKnow: "The Mayans were excellent astronomers who studied the stars and planets.",
    emoji: "🌞",
    accent: "#F59E0B",
  },
  {
    id: "colosseum",
    name: "Colosseum",
    country: "Italy",
    flag: "🇮🇹",
    continent: "Europe",
    builtBy: "The Roman Empire",
    age: "Almost 2,000 years old",
    image: img("Colosseum.jpg"),
    summary:
      "A huge stone stadium built by the Romans where people watched games and shows thousands of years ago.",
    funFact: "It could hold about 50,000 people - like a giant ancient sports arena!",
    vocabulary: { word: "Arena", meaning: "A big open area where sports or shows take place." },
    didYouKnow: "Some parts of the Colosseum are still standing after nearly 2,000 years.",
    emoji: "🏛️",
    accent: "#EF4444",
  },
  {
    id: "taj-mahal",
    name: "Taj Mahal",
    country: "India",
    flag: "🇮🇳",
    continent: "Asia",
    builtBy: "Emperor Shah Jahan",
    age: "About 370 years old",
    image: img("TajMahal.jpg"),
    summary:
      "A beautiful white marble building made by Emperor Shah Jahan in loving memory of his wife.",
    funFact: "The marble seems to change color from pink to white to gold during sunrise and sunset.",
    vocabulary: { word: "Marble", meaning: "A smooth, shiny stone used to build beautiful things." },
    didYouKnow: "It took more than 20 years and 20,000 workers to build the Taj Mahal.",
    emoji: "🕌",
    accent: "#8B5CF6",
  },
];
